
/*
ng-if overload - emits event catched by hide-empty-container
it (ng-if-applied) is also used by msdElastic (elastic.custom.js) and ng-tags-input (tagsInput)
*/
(function() {
    'use strict';

    var ngIf = function($rootScope) {
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            link: function(scope, element, attrs) {
                scope.$emit('ng-if-applied');

                element.on('$destroy', function(){
                    $rootScope.$emit('ng-if-applied');
                });
            }

        };
    }
    ngIf.$inject = ['$rootScope'];
    angular.module('app').directive('ngIf', ngIf);


    var ngShow = function($timeout) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {

                /*attrs.$observe('ngShow', function (expr) {
                    scope.$watch(function () {
                        return $parse(expr)(scope);
                    }, function (value) {
                        console.log('ngShow observe');
                        console.log(value);
                        scope.$emit('ng-if-applied');
                        $rootScope.$emit('ng-if-applied');
                    })
                });*/

                scope.$watch(attrs.ngShow, function(value) {
                    $timeout(function(){ // without timeout it's invoking the check too early so classess ng-hide/show aren't yet applied...
                        scope.$emit('ng-if-applied');
                    });
                });
            }
        };
    }
    ngShow.$inject = ['$timeout'];
    angular.module('app').directive('ngShow', ngShow);


    var ngHide = function($timeout) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {

                scope.$watch(attrs.ngHide, function(value) {
                    $timeout(function(){ // without timeout it's invoking the check too early so classess ng-hide/show aren't yet applied...
                        scope.$emit('ng-if-applied');
                    });
                });
            }
        };
    }
    ngHide.$inject = ['$timeout'];
    angular.module('app').directive('ngHide', ngHide);

}());

// once ng-show / ng-hide are overloaded we most likely don't need form-tab directive
/*
(function() {
    'use strict';

    var formTab = function($rootScope) {
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            link: function(scope, element, attrs) {
                scope.$emit('ng-if-applied');

                element.bind('click', function(){
                    $rootScope.$emit('ng-if-applied');
                });
            }

        };
    }
    angular.module('app').directive('formTab', formTab);

}());
*/


/**
@ngdoc directive
@name hideEmptyContainer

@description
The directive will hide the whole container if it doesn't contain any form fields (becomes empty).
Otherwise it's visible.

@usage
ie.
<fieldset hide-empty-container>
*/
(function() {
  'use strict';

var hideEmptyContainer = function($rootScope, $timeout) {
    return {
        restrict: 'A',
        link: function(scope, el, attrs) {

            var hiddenByThisDirective = true; // first check needs to be always performed
            var timer,
                eventOccured = 0;

            var prevState = undefined; // undefined


            function toggle(){
                // console.log(el[0]);
                // console.log('toggle()');

                var state = checkForVisibleElements();

                if( state != undefined ){
                    if(state==true){
                        // console.log("SHOWING ELEMENT!!!!");
                        hiddenByThisDirective = false;
                        el.show();
                    } else if( hiddenByThisDirective != undefined ) {
                        // console.log("HIDING ELEMENT!!!!");
                        hiddenByThisDirective = true;
                        el.hide();
                    }
                }
                return state;
            }

            scope.$on('ng-if-applied', function($event){
                scope.$evalAsync(function(){ // without evalAsync this was executed in another angular tick...
                    eventOccured++;
                });
                // if (!scope.$$phase) scope.$apply() // no-no!
            });

            $rootScope.$on('ng-if-applied', function($event){
                scope.$evalAsync(function(){ // without evalAsync this was executed in another angular tick...
                    eventOccured++;
                });
                // if (!scope.$$phase) scope.$apply() // no-no!
            });

            $timeout(function(){
                // prevState = toggle(); // first run; -TODO do we need that?

                // for some reason $watch stops working if it's only switching eventOccured between true and false (it happens with costCode)
                // ps. it might have been already fixed with $evalAsync, but design counting events it's generally safer
                scope.$watch(
                    function(){
                        return eventOccured;
                    }, function(newVal, oldVal){
                        if( newVal > 0 ){
                            if( angular.isDefined(timer) ){
                                $timeout.cancel(timer);
                            }
                            timer = $timeout(function(){
                                prevState = toggle();
                            }, 125);
                        }
                        eventOccured = 0;
                    }
                );
            });

            // check if any table or form element is visible
            function checkForVisibleElements(){
                // console.log('checkForVisibleElements()');

                if( !el.parent().is(':visible') ) {
                    // the parent is hidden, so no way to check anything...
                    return prevState;
                }

                var containerVisible = el.is(':visible');

                // for better performance
                if(!containerVisible && hiddenByThisDirective == false){
                    // the whole container is hidden outside of this directive, so no point checking any further
                    return prevState;
                }

                var returnVal = false;

                if(!containerVisible) {
                    el.show(); // container needs to be visible to check if the children form fields are visible
                }

                var fieldsVisible = el.find("[name]:visible").length; // check for visible form fields
                returnVal = fieldsVisible ? true : false;
                if(!returnVal) {
                    var tablesVisible = el.find("table:visible").length; // check for visible tables
                    returnVal = tablesVisible ? true : false;
                }
                if(!returnVal) {
                    var childrenVisible = el.children(':visible').length
                    returnVal = childrenVisible ? true : false;
                }
                if(!returnVal) {
                    var costWidgetVisible = el.find(".costWidget:visible").length; // check for visible cost widgets
                    returnVal = costWidgetVisible ? true : false;
                }
                if(!returnVal) {
                    var treeVisible = el.find(".treeView:visible").length; // check for visible dynaTrees
                    returnVal = treeVisible ? true : false;
                }
                if(!returnVal) {
                    var treeVisible = el.find(".xmsUiAttachmentNew:visible").length; // check for visible atachments
                    returnVal = treeVisible ? true : false;
                }
                // TODO: check for editable-text

                if(!containerVisible) {
                    el.hide();
                }

                return returnVal;
            }
        }
    }
}
hideEmptyContainer.$inject = ['$rootScope', '$timeout'];
angular.module('app').directive('hideEmptyContainer', hideEmptyContainer);

}());
